import axios from 'axios';

const api = axios.create({
  baseURL: 'https://painel.vaskupien.com.br/wp-json',
});

export default api;
